module.exports = __webpack_public_path__ + "static/media/A7S02417.bda212dc.jpg";